export const HIDDEN_WORKFLOW_DEFINITIONS: string[] = [
    "ContinuousCatalogGenerationRecipeV2"
];

export const HIDDEN_CLASSIFICATION_TAGS: string[] = [
    "Starfish_Touchless",
    "Starfish",
    "Retailers",
    "TEST",
    "Dawn",
    "Zuma"
];
